import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
import zoom from 'chartjs-plugin-zoom';

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData','options'],
  mounted () {
    this.addPlugin("zoom",zoom);

    this.renderChart(this.chartData, this.options)

  }
}